// extracted by mini-css-extract-plugin
module.exports = {"passInfomation":"style_passInfomation__csi6W","passInfomation__Wrapper":"style_passInfomation__Wrapper__StGJ9","passInfomation__Text":"style_passInfomation__Text__SdglS"};